<template>
  <main class="main" role="main">
    <div class="main__inner bg"><!-- 배경: bg-->
      <div class="main__con" v-if="isReady" id="main__con" @scroll="scrollMain">
        <div class="report-title">
          <input type="month" v-model="searchStartDate">
          <div class="half">~</div>
          <input type="month" v-model="searchEndDate">
          <button type="button" class="btn-search" @click="validSearchDate">검색</button>
        </div>
        <div class="p16" v-if="assetList.length <= 0">
          <div class="complete m36">
            <p class="complete__txt"><span class="primary">보고서 정보가 없습니다.</span></p>
            <p class="complete__txt__small" style="margin-top: 1.2rem;">
              전기요금 컨설팅 보고서 자료가 등록되지 않았습니다.<br>
              문의사항은 '불편사항 접수'로 문의 부탁드립니다.
            </p>
          </div>
          <div class="btn m26">
            <button class="left" @click="$router.push('/mypage/inquire')">불편사항 접수</button>
          </div>
        </div>
        <div v-else>
          <!--          <div class="report-date">-->
          <!--            {{-->
          <!--              `${assetList[0].assetYear}년 ${assetList[0].assetMonth}월 ~ ${assetList[assetList.length - 1].assetYear}년 ${assetList[assetList.length - 1].assetMonth}월`-->
          <!--            }}-->
          <!--          </div>-->
          <div class="line"></div>
          <div class="report-section">

            <div class="report-total">
              <ul class="total-content" v-if="electData.electType === 1">
                <li>중부하</li>
                <li class="kwh">{{ $Util.formatNumber(totalData.totalHeavyLoad) }}</li>
                <li>컨설팅전</li>
                <li class="won">{{ $Util.formatNumber(totalData.sumBeforeTotalBill) }}</li>
                <li>최대부하</li>
                <li class="kwh">{{ $Util.formatNumber(totalData.totalMaxLoad) }}</li>
                <li>컨설팅후</li>
                <li class="won">{{ $Util.formatNumber(totalData.sumAfterTotalBill) }}</li>
                <li>경부하</li>
                <li class="kwh">{{ $Util.formatNumber(totalData.totalLightLoad) }}</li>
                <li>절감금액</li>
                <li class="won">{{ $Util.formatNumber(totalData.sumSavePrice) }}</li>
                <li>합계</li>
                <li class="kwh">{{ $Util.formatNumber(totalData.totalSumLoad) }}</li>
                <li>절감율</li>
                <li class="per">{{ totalData.savePriceRateAverage }}</li>
              </ul>
              <ul class="total-content" v-else>
                <li>컨설팅전</li>
                <li class="won">{{ $Util.formatNumber(totalData.sumLowBeforeTotalBill) }}</li>
                <li>컨설팅후</li>
                <li class="won">{{ $Util.formatNumber(totalData.sumLowAfterTotalBill) }}</li>
                <li>절감금액</li>
                <li class="won">{{ $Util.formatNumber(totalData.sumLowSavePrice) }}</li>
                <li>절감율</li>
                <li class="per">{{ totalData.sumLowSavePriceRate }}</li>
              </ul>
            </div>
            <div class="line"></div>
            <div class="report-table">
              <ul class="report-table-content">
                <li v-for="(asset, index) in assetList" :key="index">
                  <div class="content-title">
                    <div class="content-date">
                      {{ `[${asset.assetYear}년 ${asset.assetMonth}월]` }}
                    </div>
                    <div class="content-more" @click="detailPage(asset)">
                      자세히<i class="i_right"></i>
                    </div>
                  </div>
                  <div class="content-item">
                    <label>사용기간</label>
                    <span>{{ `${asset.startUseDate1} ~ ${asset.endUseDate1}` }}</span>
                  </div>
                  <div class="content-item">
                    <label>컨설팅전</label>
                    <span v-if="electData.electType === 1">{{ $Util.formatNumber(asset.beforeTotalBill) }}원</span>
                    <span v-else>{{ $Util.formatNumber(asset.afterTotalBill1 + asset.savePrice) }}원</span>
                  </div>
                  <div class="content-item">
                    <label>컨설팅후</label>
                    <span>{{ $Util.formatNumber(asset.afterTotalBill1 + asset.afterTotalBill2) }}원</span>
                  </div>
                  <div class="content-item">
                    <label>절감금액</label>
                    <span>{{ $Util.formatNumber(asset.savePrice) }}원</span>
                  </div>
                  <div class="content-item">
                    <label>절감율</label>
                    <span>{{ `${asset.savePriceRate}%` }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="move-top" @click="$Util.scrollToTop('main__con')" v-show="isMoveTopShow">
          <img src="@/assets/static/images/up-arrow.png">
        </div>
      </div>
    </div>
  </main>
</template>
<script>
// import { MonthPickerInput } from 'vue-month-picker'
import "vue-scroll-picker/dist/style.css"

export default {
  components: {
    // MonthPickerInput
  },
  data: function () {
    return {
      isMoveTopShow: false,
      isReady: false,
      electData: {},
      totalData: {
        totalHeavyLoad: 0,
        sumBeforeTotalBill: 0,
        totalMaxLoad: 0,
        sumAfterTotalBill: 0,
        totalLightLoad: 0,
        sumSavePrice: 0,
        totalSumLoad: 0,
        savePriceRateAverage: 0,
        sumLowBeforeTotalBill: 0,
        sumLowAfterTotalBill: 0,
        sumLowSavePrice: 0,
        sumLowSavePriceRate: 0,
      },
      assetList: [],
      searchStartDate: '',
      searchEndDate: '',
      params: {
        userNo: '',
        searchStartYear: '',
        searchStartMonth: '',
        searchEndYear: '',
        searchEndMonth: '',
        page: 1,
        limit: 20,
      }
    }
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    },
  },
  watch: {
    searchStartDate: function (value) {
      const split = value.split('-')
      if (split.length > 0) {
        this.params.searchStartYear = split[0]
        this.params.searchStartMonth = split[1]
      }
    },
    searchEndDate: function (value) {
      const split = value.split('-')
      if (split.length > 0) {
        this.params.searchEndYear = split[0]
        this.params.searchEndMonth = split[1]
      }
    }
  },
  created: async function () {
    if (this.userData.userType === 2) {
      let tempLayout = this.$store.getters['layout/getLayout']
      tempLayout.isFooter = false
      this.$store.commit('layout/setLayout', {
        titleName: '절감 보고서',
        isHeader: tempLayout.isHeader,
        isFooter: false,
        isMain: tempLayout.isMain,
        headerIconType: tempLayout.headerIconType,
        isTab: tempLayout.isTab,
        tabType: tempLayout.tabType,
        isMypage: tempLayout.isMypage
      })
      console.log(this.$store.getters['layout/getLayout'])
    }
    await this.getAssetReportData()
  },
  methods: {
    scrollMain: function (e) {
      if (e === undefined) {
        return false
      }

      this.isMoveTopShow = e.target.scrollTop > 320
    },
    validSearchDate: function () {
      const startMoment = this.$moment(this.searchStartDate)
      const endMoment = this.$moment(this.searchEndDate)
      if (startMoment.isAfter(endMoment)) {
        this.$Util.modalAlert({message: '검색기간을 확인해주세요.'})
        return false
      }

      this.getAssetReportData()
    },
    detailPage: function (asset) {
      // 고압인 경우 그대로
      if (this.electData.electType === 1) {
        this.$router.push({
          path: '/main/reportDetail',
          query: {
            assetNo: asset.assetNo,
            assetYear: asset.assetYear,
            assetMonth: asset.assetMonth
          }
        })
      }
      // 저압인 경우 새로운 상세 페이지로
      else {
        this.$router.push({
          path: '/main/reportDetailLow',
          query: {
            assetNo: asset.assetNo,
            assetYear: asset.assetYear,
            assetMonth: asset.assetMonth
          }
        })
      }
    },
    getAssetReportData: async function () {
      this.params.userNo = this.$Util.isEmpty(this.$route.query.userNo) ? this.userData.userNo : this.$route.query.userNo
      const res = await this.$AssetSvc.getAssetReportData(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.assetList = entity.assetList
        this.electData = entity.electData

        this.calculation()
      }
    },
    calculation: function () {
      this.assetList.forEach(items => {
        this.totalData.totalHeavyLoad += items.heavyLoad1_1 + items.heavyLoad1_2 + items.heavyLoad2_1 + items.heavyLoad2_2
        this.totalData.totalMaxLoad += items.maxLoad1_1 + items.maxLoad1_2 + items.maxLoad2_1 + items.maxLoad2_2
        this.totalData.totalLightLoad = items.lightLoad1_1 + items.lightLoad1_2 + items.lightLoad2_1 + items.lightLoad2_2
        this.totalData.totalSumLoad += this.totalData.totalHeavyLoad + this.totalData.totalMaxLoad + this.totalData.totalLightLoad

        this.totalData.sumBeforeTotalBill += items.beforeTotalBill
        this.totalData.sumAfterTotalBill += items.afterTotalBill1 + items.afterTotalBill2
        this.totalData.sumSavePrice += items.savePrice
        this.totalData.savePriceRateAverage += items.savePriceRate

        this.totalData.sumLowBeforeTotalBill += items.afterTotalBill1 + items.savePrice
        this.totalData.sumLowAfterTotalBill += items.afterTotalBill1
        this.totalData.sumLowSavePrice += items.savePrice
        this.totalData.sumLowSavePriceRate += items.savePriceRate
      })

      this.totalData.savePriceRateAverage = Math.round(this.totalData.savePriceRateAverage / this.assetList.length * 100) / 100
      this.totalData.sumLowSavePriceRate = Math.round(this.totalData.sumLowSavePriceRate / this.assetList.length * 100) / 100

      this.isReady = true
    }
  }
}
</script>

<style lang="scss" scoped>

.report-title {
  padding: 1rem;

  div.half {
    display: inline-block;
    vertical-align: middle;
    font-size: 1.4rem;
    font-weight: bold;
    width: 2rem;
    text-align: center;
    line-height: 3.2rem;
  }

  input {
    vertical-align: middle;
    display: inline-block;
    width: calc(35%);
    border: #eeeeee solid 1px;
    font-size: 1.4rem;
    text-align: center;
    margin: 0;
    padding: 0;
    height: 3.2rem;
    line-height: 3.2rem;
    border-radius: 0.4rem;
  }


  //input[type=month]::-webkit-datetime-edit-text { -webkit-appearance: none; display: none; }
  //input[type=month]::-webkit-datetime-edit-month-field{ -webkit-appearance: none; display: none; }
  //input[type=month]::-webkit-datetime-edit-day-field { -webkit-appearance: none; display: none; }
  //input[type=month]::-webkit-datetime-edit-year-field { -webkit-appearance: none; display: none; }
  //input[type=month]:before {
  //  content: 'YYYY-MM'
  //}


  .btn-search {
    vertical-align: middle;
    padding: 0;
    display: inline-block;
    width: calc(30% - 4rem);
    margin: 0 0 0 2rem;
    height: 3rem;
    background-color: #1980C3;
    color: white;
    font-size: 1.4rem;
    font-weight: bold;
    border-radius: 0.4rem;
  }

}

.report-section {
  background-color: white;
}

.report-date {
  font-size: 1.6rem;
  font-weight: bold;
  background-color: #F5F5F5;
  color: black;
  padding: 1rem;
}

.report-total {
  padding: 1.5rem 2rem 4rem;
  color: white;
  background-color: #1980C3;

  & > ul.total-content {
    font-size: 1.25rem;
    line-height: 2.4rem;

    & > li {
      display: inline-block;

      &.kwh:after {
        font-size: 1.2rem;
        font-weight: normal;
        content: 'Kwh'
      }

      &.won:after {
        font-size: 1.2rem;
        font-weight: normal;
        content: '원'
      }

      &.per:after {
        font-size: 1.2rem;
        font-weight: normal;
        content: '%'
      }

      &:nth-child(odd) {
        width: 15%;
        font-weight: bold;
        text-align: center;
      }

      &:nth-child(even) {
        width: calc(35% - 0.5rem);
        font-weight: bold;
        text-align: right;
      }

      &:nth-child(even):not(:nth-child(4n)) {
        margin-right: 1rem;
      }
    }
  }
}

.report-table {
  padding: 1.2rem;
  background-color: #FAFAFA;

  ul.report-table-content {
    li {
      //box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.5);
      font-size: 1.1rem;
      margin-bottom: 1rem;
      padding: 1.5rem;
      border: 1px solid #EEEEEE;
      border-radius: 0.5rem;
      background-color: white;

      &:first-child {
        margin-top: -4rem;
      }

      div.content-title {
        margin-bottom: 1rem;

        div.content-date {
          width: 70%;
          display: inline-block;
          font-size: 1.6rem;
          font-weight: bold;
        }

        div.content-more {
          display: inline-block;
          width: 30%;
          font-size: 1.4rem;
          font-weight: bold;
          text-align: right;

          .i_right {
            background-image: url('~src/assets/static/images/i_right.svg');
            background-size: 100%;
            background-repeat: no-repeat;
            width: 1.9rem;
            height: 1.9rem;
          }
        }
      }

      div.content-item {
        margin-left: 3rem;

        label {
          width: 20%;
          display: inline-block;
          font-size: 1.4rem;
          font-weight: bold;
        }

        span {
          display: inline-block;
          font-size: 1.4rem;
          margin-left: 1rem;
          text-align: right;
          width: 60%;
          color: #616161;
        }
      }
    }
  }
}

.date-picker-popup {
  position: absolute;
  border: #EEEEEE solid 1px;
  box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.5);
  width: calc(100% - 10rem);
  height: 20rem;
  margin-top: 0.5rem;
  background-color: white;
  z-index: 15;

  &.right {
    right: 1rem;
  }

  .vue-scroll-picker {
    display: inline-block;
    width: 50%;
    height: 16rem;
    font-size: 1.6rem;
  }

  .button-wrap {
    width: 100%;

    .btn-cancel {
      display: inline-block;
      background-color: #c42c2c;
      width: 50%;
      height: 100%;
      border: 0;
      color: white;
      font-size: 1.4rem;
      font-weight: bold;
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }

    .btn-select {
      display: inline-block;
      background-color: #1980C3;
      width: 50%;
      border: 0;
      color: white;
      font-size: 1.4rem;
      font-weight: bold;
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }
  }
}

.move-top {
  z-index: 9999;
  position: fixed;
  right: 0.5rem;
  bottom: 7rem;
  width: 4.8rem;
  height: 4.8rem;
}
</style>

<style lang="scss">
.vue-scroll-picker-item {
  height: 4rem;
  line-height: 4rem;
}

.vue-scroll-picker-layer {
  .top {
    height: calc(33%);
  }

  .middle {
    top: 33%;
    height: calc(33%);
  }

  .bottom {
    height: calc(33%);
  }
}
</style>
